<template>
  <div>
    <iframe width="100%" height="1000px"
      src="https://lookerstudio.google.com/embed/reporting/12491773-b4ae-45c1-9b40-c041701c6193/page/9rBaF"
      frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
}
</script>
